import Yup from '~/utils/validations/yup';

export const schemaValidation = Yup.object({
  currentPassword: Yup.string().min(6),
  password: Yup.string().min(6).password(),
});
